import { generateText, type JSONContent } from "@tiptap/core";
import { richTextEditorExtensions } from "../../../../shared/rich-text-document";

/**
 * Meeting Notes use the app-local shared TipTap schema, including heading
 * levels 1–3. The server-side validator uses the same configuration
 * (server/lib/meeting-note-editor.ts), so stored documents and both editors
 * keep one format contract.
 */
export const meetingNoteEditorExtensions = richTextEditorExtensions;

export function meetingNoteTextFromJson(bodyJson: JSONContent): string {
  return generateText(bodyJson, meetingNoteEditorExtensions)
    .replace(/\s+/g, " ")
    .trim();
}
